<template>
  <div>
    <!-- 首頁导航 -->
    <div class="nav">
      <img class="logo" @click="goHome()" src="../../assets/img/common/logo.png" alt="">
      <div class="navigation">
        <a @click="goHome()"><span>首頁</span></a>
        <router-link to="/product"><span>產品</span></router-link>
        <!-- <router-link to="/register">申請成為商家</router-link> -->
        <a @click="register()"><span>申請成為商家</span></a>
        <router-link to="/partner"><span>合作夥伴</span></router-link>
        <router-link to="/developer"><span>開發人員</span></router-link>
        <a @click="goTest()"><span>常見問題</span></a>
        <router-link to="/contact"><span>聯絡我們</span></router-link>
      </div>

    </div>
    <!-- 手机版 -->
    <div class="app_nav">
      <img class="logo" @click="goHome()" src="../../assets/img/common/logo.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    register() {
      this.$router.push("/register");
      this.$router.go(0);
    },
    goHome(){
      this.$router.push("/");
      this.$router.go(0);
    },
    goTest(){
      this.$router.push("/test/20");
      this.$router.go(0);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav {
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  min-width: 1200px;
  margin-top: 30px;
  margin-bottom: 16px;
  box-sizing: border-box
}
.nav .logo {
  margin-left: 28px;
  width: 112px;
  height: 50px;
  
}
.nav .navigation {
  margin-right: 28px; 

}
.navigation a {
  color: #777777;
  padding: 0px 12px;
  border-left: 1px solid #777777;
  cursor: pointer;
}
.navigation a:hover span {
  padding-bottom: 2px;
  border-bottom: #e73262 2px solid;
}
.navigation a:first-child {
  border-left: 0;
}


/* 手机版 */
.app_nav {
  display: none;
  justify-content: center;
  margin: 4vw 0 2.4vw;
}
.app_nav img {
  width: 14.7vw;
  height: 6.7vw;
}


/*  */
@media screen and (max-width:768px){
  .app_nav {
    display: flex;
  }
  .nav {
    display: none;
  }

}


</style>
